// extracted by mini-css-extract-plugin
module.exports = {"redirect":"redirect_redirect__1dP5W","title":"redirect_title__3ym6C","subTitle":"redirect_subTitle__2e-S5"};